import { Alert } from "react-bootstrap";
import React, { ReactNode } from "react";

const Footnote = (props: {
  text?: ReactNode | null
}) => {
  const { text } = props;

  if (!text) {
    return null;
  }

  return (
    <Alert variant="light" className="footnote">{text}</Alert>
  )
}

export default Footnote;
